"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@rill/http");
var HttpError = /** @class */ (function () {
    /**
     * Creates a Rill HttpError.
     *
     * @param statusCode The http status code for the error.
     * @param statusMessage The http status message for the error.
     * @param metaData An object to be merged with the error.
     */
    function HttpError(statusCode, statusMessage, metaData) {
        if (typeof statusCode !== "number") {
            throw new TypeError("Rill#HttpError.fail: Status code must be a number.");
        }
        if (typeof metaData === "object") {
            for (var key in metaData) {
                this[key] = metaData[key];
            }
        }
        this.code = statusCode;
        this.name = "HttpError";
        this.message = statusMessage || http_1.STATUS_CODES[statusCode];
        Error.call(this, statusMessage);
        /* istanbul ignore else  */
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpError);
        }
    }
    return HttpError;
}());
HttpError.prototype = Object.create(Error.prototype);
module.exports = exports = HttpError;
exports.default = HttpError;
/**
 * Throw an http error.
 *
 * @param code The status code for the error.
 * @param message Optional status message.
 * @param meta Optional object to merge onto the error.
 * @throws {HttpError}
 */
function fail(code, message, meta) {
    throw new HttpError(code, message, meta);
}
exports.fail = fail;
/**
 * Throw an http error.
 *
 * @param value The value to test for truthyness.
 * @param code The status code for the error.
 * @param message Optional status message.
 * @param meta Optional object to merge onto the error.
 * @throws {HttpError}
 */
function assert(value, code, message, meta) {
    if (!value) {
        fail(code, message, meta);
    }
}
exports.assert = assert;
//# sourceMappingURL=index.js.map